import { Stack, Text } from "@mantine/core"
import { useId } from "react"
import { useTranslation } from "react-i18next"
import { InvitedCompanySummary } from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/verifyCompanyOutcome.types"
import { VerifyCompanyOutcome } from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/verifyCompanyOutcome.types"

import { VerifyCompanyOutcomeRadioGroup } from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/VerifyCompanyOutcomeRadioGroup"
import {
  VerifyCompanySummaryCard,
} from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/VerifyCompanySummaryCard"
type VerifyCompanyOutcomeStepProps = Readonly<{
  invitedCompany: InvitedCompanySummary
  selectedOutcome: VerifyCompanyOutcome
  selectOutcome: (outcome: VerifyCompanyOutcome) => void
  handleContinue: () => boolean
}>
export const VerifyCompanyOutcomeStep = ({
  invitedCompany,
  selectedOutcome,
  selectOutcome,
}: VerifyCompanyOutcomeStepProps) => {
  const { t } = useTranslation("supplier")
  const promptId = useId()

  return (
    <Stack gap="var(--tfg-organism-padding-y)" >
      <Text component="p" id={promptId} size="sm" fw={500} m={0}>
        {t("onboarding.verifyCompany.prompt")}
      </Text>
      <VerifyCompanySummaryCard company={invitedCompany} />
      <VerifyCompanyOutcomeRadioGroup
        aria-labelledby={promptId}
        onSelectOutcome={selectOutcome}
        selectedOutcome={selectedOutcome}
      />
    </Stack>
  )
}
